import * as React from 'react';
import Button from '../Buttons/Button';
import {ReactNode} from 'react';

interface PageHeaderProps {
    action?: string;
    border?: boolean;
    centered?: boolean;
    children?: ReactNode;
    className?: string;
    id?: string;
    onClick?: () => void;
    title?: string | ReactNode;
    type: `h1` | `h4`;
    wrap?: boolean;
    e2e?: string;
}

export const PageHeader = ({
    action,
    border = true,
    centered = false,
    children,
    className,
    id,
    onClick,
    title,
    type,
    wrap = false,
    e2e,
}: PageHeaderProps) => (
    <>
        {type === `h1` && (
            <h1
                className={`tw-text-[28px] md:tw-text-[40px] lg:tw-text-[40px] tw-items-center tw-flex tw-justify-between${
                    wrap ? ' tw-flex-wrap' : ' tw-flex-nowrap'
                }${border ? ' tw-border-b tw-pb-0 md:tw-pb-1 lg:tw-pb-1 tw-mb-6' : ' tw-mb-3'}${
                    centered ? ' tw-justify-center' : ' tw-justify-between'
                }${className ? ` ${className}` : ''}`}
                id={id}
                data-e2e={e2e}
            >
                {title}
                {action && (
                    <Button
                        className="tw-mt-1 !tw-px-4"
                        onClick={onClick}
                        e2e="pageHeaderActionCreateNewList"
                        size="sm"
                        variant="link"
                    >
                        {action}
                    </Button>
                )}
                {children}
            </h1>
        )}
        {type === `h4` && (
            <h4
                className={`tw-text-2xl tw-font-bold tw-p-1 tw-flex tw-justify-between${wrap ? ' tw-flex-wrap' : ' tw-flex-nowrap'}${
                    border ? ' tw-border-b tw-mb-5' : ' tw-mb-3'
                }`}
                id={id}
            >
                {title}
                {action && (
                    <span>
                        <Button
                            className="!tw-px-4"
                            onClick={onClick}
                            size="sm"
                            variant="link"
                        >
                            {action}
                        </Button>
                    </span>
                )}
                {children}
            </h4>
        )}
    </>
);
